import { cva, type VariantProps } from 'noddi-ui-common';
import { formatSwitcherIndex } from './numberedIndexBuffer';

const switcherIndexBadgeVariants = cva(
  'flex shrink-0 items-center justify-center rounded-sm border font-medium tabular-nums',
  {
    variants: {
      highlighted: {
        true: 'border-primary bg-primary text-primary-foreground',
        false: 'border-border bg-muted text-muted-foreground'
      },
      size: {
        sm: 'h-5 min-w-5 px-1 text-[11px]',
        md: 'h-7 min-w-7 px-1.5 text-sm font-semibold'
      }
    },
    defaultVariants: {
      highlighted: false,
      size: 'sm'
    }
  }
);

// Numbered badge shown on every switcher row, kept in one place so the org column,
// department column and flat list render an identical badge. `highlighted` is the
// typed / current path number — muted badges disappear against the row.
// When `total` is 10+, labels pad (`01`…`11`) so double-digit indexes are obvious.
export function SwitcherIndexBadge({
  n,
  total = 1,
  highlighted,
  size
}: { n: number; total?: number } & VariantProps<typeof switcherIndexBadgeVariants>) {
  return <span className={switcherIndexBadgeVariants({ highlighted, size })}>{formatSwitcherIndex(n, total)}</span>;
}
